import { useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";

/**
 * Composant simplifié pour vérifier qu'un restaurant est sélectionné
 * Redirige vers la page des restaurants si aucun restaurant n'est sélectionné
 */
const CheckRestauSelected = ({ storageKey = "user" }) => {
  const navigate = useNavigate();
  const route = all_routes;

  useEffect(() => {
    const raw = localStorage.getItem(storageKey);
    
    if (!raw) {
      navigate(route.Restaurants);
      return;
    }

    try {
      const data = JSON.parse(raw);
      if (!data["restoId"]) {
        navigate(route.Restaurants + "?select=true");
      }
    } catch (e) {
      console.error("Erreur parsing localStorage:", e);
      navigate(route.Restaurants);
    }
  }, [storageKey, navigate, route.Restaurants]);

  return null; // Ce composant ne rend rien
};

CheckRestauSelected.propTypes = {
  storageKey: PropTypes.string,
};

export default CheckRestauSelected;